import React from 'react';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import type { SVFormValues } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecificVendorEndorsementModal';
import { SpecificVendorEndorsementModalConfig } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecificVendorEndorsementModal';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { SpecificVendor } from '../../../../../../api/types/rater-x-preset';
import { useLocale } from '../../../../../../providers/LocaleProvider';

const SpecificVendorEndorsement = (props: AmendatoryLineItemProps) => {
  const locale = useLocale();

  const handleAddVendors = (formValues: SVFormValues) => {
    const _vendors = formatVendorsForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          items: { values: _vendors as unknown as SpecificVendor[] },
        },
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(SpecificVendorEndorsementModalConfig, {
          data: {
            onSubmit: handleAddVendors,
            vendors: getDefaultVendorValues(
              props.value?.props?.items?.values as SpecificVendor[]
            ),
            language: locale.language,
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.items?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default SpecificVendorEndorsement;

export function getDefaultVendorValues(
  values: SpecificVendor[] | undefined
) {
  if (!values) {
    return [];
  }

  return values.map((value) => {
    return {
      name: value.props.name.value ?? '',
      rate: value.props.rate.value ?? 0,
    };
  });
}

export function formatVendorsForState(formValues: SVFormValues) {
  return formValues.vendors.map((vendor) => {
    return {
      props: {
        name: { value: vendor.name },
        rate: { value: vendor.rate },
      },
    };
  });
}
